import { render, staticRenderFns } from "./maoBox.vue?vue&type=template&id=5e0fee5a&scoped=true"
import script from "./maoBox.vue?vue&type=script&lang=js"
export * from "./maoBox.vue?vue&type=script&lang=js"
import style0 from "./maoBox.vue?vue&type=style&index=0&id=5e0fee5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0fee5a",
  null
  
)

export default component.exports